module.exports = __webpack_public_path__ + "9ba2d753e7f5784bbf552dc185ec4556.png";